export default __webpack_public_path__ + "media/src/assets/images/DOT_hazmat_class_1.6-5cf9a565a92166e34afb7399593c6122.svg";